var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "modalButtonNav",
    staticClass: "new-modal-button-nav"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ctaSecondaryButton && _vm.showCtaSecondaryButton,
      expression: "ctaSecondaryButton && showCtaSecondaryButton"
    }, {
      name: "tooltip",
      rawName: "v-tooltip",
      value: _vm.ctaSecondaryTooltip,
      expression: "ctaSecondaryTooltip"
    }],
    staticClass: "new-modal-button-nav-container"
  }, [_c('button', {
    staticClass: "new-modal-button-nav-container-cta button expanded secondary",
    attrs: {
      "disabled": _vm.blockCtaSecondaryButton,
      "type": "button",
      "aria-label": _vm.getStringTranslation(_vm.ctaSecondaryButton),
      "role": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.ctaSecondaryAction();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getStringTranslation(_vm.ctaSecondaryButton)) + "\n    ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.ctaPrimaryButton && _vm.showCtaPrimaryButton,
      expression: "ctaPrimaryButton && showCtaPrimaryButton"
    }, {
      name: "tooltip",
      rawName: "v-tooltip",
      value: _vm.ctaPrimaryTooltip,
      expression: "ctaPrimaryTooltip"
    }],
    staticClass: "new-modal-button-nav-container"
  }, [_c('button', {
    staticClass: "new-modal-button-nav-container-cta button expanded primary",
    attrs: {
      "disabled": _vm.blockCtaPrimaryButton,
      "type": "button",
      "aria-label": _vm.getStringTranslation(_vm.ctaPrimaryButton),
      "role": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.ctaPrimaryAction();
      }
    }
  }, [_c('span', {
    staticClass: "new-modal-button-nav-container-cta-text"
  }, [_vm._v("\n        " + _vm._s(_vm.getStringTranslation(_vm.ctaPrimaryButton)) + "\n      ")]), _vm.ctaPrimaryButtonIconType === 'svg' ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showIconButton,
      expression: "showIconButton"
    }],
    staticClass: "new-modal-button-nav-container-cta-icon",
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/customizer/").concat(_vm.ctaPrimaryButtonIconName, ".svg"),
      "alt": "",
      "aria-hidden": "true"
    }
  }) : _c('span', {
    class: "new-modal-button-nav-container-cta-icon icon icon-".concat(_vm.ctaPrimaryButtonIconName)
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }